<template>
  <div class="nearby-wrapper">
    <div class="top">
      <svg>
        <use xlink:href="#icon-center"></use>
      </svg>
      <h2>
        {{ $t('components.nearby_businesses.near') }} {{ city.label }}
      </h2>
    </div>
    <nearby-business-slider :businesses="businessesList" />
  </div>
</template>
<script>
import NearbyBusinessSlider from './NearbyBusinessSlider'

export default {
  name: 'NearbyBusinesses',
  props: {
    city: {
      type: Object,
      required: true,
    },
  },
  components: {
    NearbyBusinessSlider,
  },
  created() {
    this.getBusinesses()
  },
  computed: {
    currentBusinessId() {
      return window.renaultRent.business_id
    },
    businessesList() {
      return this.$store.state.businessSearch.businesses.filter((bus) => bus.id !== window.renaultRent.business_id)
    },
  },
  methods: {
    getBusinesses() {
      this.$store.dispatch('businessSearch/GET_BUSINESSES_FOR_CITY', { city: this.city, overrideLoader: true })
    },
  },

}
</script>
<style lang="scss" scoped>

.nearby-wrapper {
  background: $c-alabaster;
}

.top {
  align-items: center;
  display: flex;
  margin: 0 0 10px;
}

svg {
  fill: black;
  height: 25px;
  margin: 0 10px 0;
  width: 25px;
}

h2 {
  align-items: center;
  background: $c-mine-shaft;
  color: white;
  display: flex;
  flex-grow: 1;
  margin: 0;
  min-height: 48px;
  padding: 0 0 0 10px;
  width: calc(100% - 50%);
}

.aligner {
  align-items: flex-end;
  display: flex;
  padding: 0 30px;
  width: 100%;
}
</style>
